<template>
	<div class="about" id="about" :class="{ 'gray': gray }">
		<div class="box">
			<SubTitle topTitle='ABOUT US' :title="$t('nav.about')" :content='aboutText' />

			<!-- /* 2022-10-17  隐藏 关于我们信息 */ -->
			<div class="switch_tab" v-if="false">
				<div class="switch_item" v-for="(item, index) in aboutList" @click="hSwitchTab(index)">
					<!-- <img width="46" :src="index == current ? item.image : item.check_image"> -->
					<div class="switch_bg" :class="index == current ? 'check' : 'uncheck'">
						<img width="46" :src="index == current ? item.check_image : item.image"
							style="margin-bottom: 0.625rem;">
						<span>{{ item.title }}</span>
					</div>
				</div>
			</div>

			<div class="content_box" v-if="false">
				<div class="content" :style="{ left: leftSpace }">
					<span>{{ aboutList[current] ? aboutList[current].title : '' }}</span>
					<div class="about-content" v-html="aboutList[current] ? aboutList[current].content : ''"></div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getAboutText, getAboutList } from '@/utils/api.js'
import SubTitle from './SubTitle'
export default {
	name: 'About',
	props: {
		windowWidth: [String, Number]
	},
	components: {
		SubTitle
	},
	data() {
		return {
			aboutText: '',
			aboutList: [],

			current: 0,
			leftSpace: ''
		}
	},
	computed: {
		...mapState(['gray'])
	},
	created() {
		this.getAboutText()
		this.getAboutList()
	},
	methods: {
		async getAboutText() {
			const res = await getAboutText()
			if (res.code == 200) {
				this.aboutText = res.content.content
			}
		},
		async getAboutList() {
			const res = await getAboutList()
			if (res.code == 200) {
				this.aboutList = res.content
			}
		},
		hSwitchTab(index) {
			// console.log("windowWidth: ",this.windowWidth);
			this.current = index
			if (this.windowWidth < 480) return this.leftSpace = '-100px'
			switch (this.current) {
				case 0:
					this.leftSpace = '100px'
					break;
				case 1:
					this.leftSpace = '200px'
					break;
				case 2:
					this.leftSpace = '300px'
					break;
				case 3:
					this.leftSpace = '400px'
					break;
				// case 4:
				// 	this.leftSpace = '400px'
				// 	break;
				default:
					break;
			}
		}
	}
}
</script>

<style>
.about {
	width: 100%;
	/* 2022-10-17  隐藏 关于我们信息 */
	/* height: 54.25rem; */
	background: url(../assets/bg2.jpg) no-repeat center;
	background-size: cover;
}

.about .box {
	padding: 3.2rem 0 6.25rem;
	max-width: 75rem;
	margin: 0 auto;
}

.switch_tab {
	padding-top: 1.25rem;
	display: flex;
	justify-content: center;
}

.switch_item {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 10px;
}

.switch_item:last-child {
	margin-right: 0;
}

.switch_bg {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 1.25rem 1.25rem 1.875rem;
	background-size: cover;
	background-repeat: no-repeat;
	text-align: center;
}

.check {
	background: url(../assets/current_bg.png) no-repeat center;
	/* width: 9.375rem;
		height: 9.1875rem; */
	width: 16.25rem;
	height: 9.1875rem;
	background-size: contain;
}

.uncheck {
	background: url(../assets/un_current_bg.png) no-repeat center;
	/* width: 8.75rem;
		height: 8.375rem; */
	width: 16.25rem;
	height: 8.375rem;
	background-size: contain;
}

.content_box {
	background: url(../assets/about_bg1.png) no-repeat center;
	max-width: 1086px;
	height: 223px;
	position: relative;
	top: 1.875rem;
	z-index: 2;
}

.content {
	background: url(../assets/about_bg2.png) no-repeat center;
	width: 575px;
	height: 302px;
	position: absolute;
	top: -1.875rem;
	left: 80px;
	padding: 40px 60px;
	box-sizing: border-box;
	z-index: 3;
}

.content span {
	font-size: 1.5rem;
	border-bottom: 0.125rem solid #FFFFFF;
}

/* .content>div {
		margin-top: 0.625rem;
		line-height: 1.5rem;
		max-height: 168px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 8;
		! autoprefixer: off //
		-webkit-box-orient: vertical;
		autoprefixer: on //

	} */

@media screen and (max-width:480px) {
	.switch_tab {
		/* transform: scale(.34); */
		transform: scale(.34) translateY(-138px);
	}

	.content_box {
		/* transform: scale(.7); */
		transform: scale(.9) translateY(-160px);
	}

	.content_box .content {
		/* transform: scale(.8);
			padding: 10px 25px;
			left: -40px; */
		transform: scale(.67);
		padding: 10px 25px;
		top: -35px;
		left: -100px;
	}
}
</style>
